import { DateCodes } from '@maxpreps/apiserviceclients/apiModels';
import SmartAnchor from '@maxpreps/shared/corecomponents/Anchor/SmartAnchor';
import Image from '@maxpreps/shared/corecomponents/Image/Image';
import { Tablet } from '@maxpreps/shared/corecomponents/ScreenSize/ScreenSize';
import {
  DateFormat,
  formatTimestamp
} from '@maxpreps/shared/functions/primitiveHelpers/dateTimeHelpers';
import { getHomeAwayText } from '@maxpreps/shared/functions/utils/contestUtils';
import { useIsMobile } from '@maxpreps/shared/hooks/useIsScreenSize';
import THEME from '@maxpreps/shared/styles/colors';
import Font from '@maxpreps/shared/styles/font';
import styled from 'styled-components';
import { IScheduleCallout } from '../../../utils/schedule/getCalloutInfo';
import ScheduleMascot from '../ScheduleRow/ScheduleMascot';

const StyledScheduleCalloutRow = styled.div<{ $minWidth: number }>`
  display: flex;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${THEME.general.border};
  :hover {
    background-color: ${THEME.surface.tertiary};
  }

  .left,
  .right {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .left > :first-child {
    min-width: ${props => props.$minWidth}px;
  }

  .right > :last-child {
    color: ${THEME.status.negative};
  }

  .city-state {
    white-space: pre-wrap;
    color: ${THEME.text.tertiary};
  }
`;

interface ScheduleCalloutRowProps {
  callout: IScheduleCallout;
  isRightRail?: boolean;
}

const ScheduleCalloutRow: React.FC<ScheduleCalloutRowProps> = ({
  callout,
  isRightRail
}) => {
  const isMobile = useIsMobile() || isRightRail;

  const { href, as, text, imgSrc, contest } = callout;
  const { currentTeam, opponentTeam } = contest;
  const { state, city, isTeamTBA, name } = opponentTeam;

  return (
    <SmartAnchor as={as} href={href} $color={THEME.text.primary}>
      <StyledScheduleCalloutRow $minWidth={isMobile ? 60 : 70}>
        <div className="left">
          <span className={isMobile ? Font.f12_bold_tall : Font.f14_bold_tall}>
            {contest.dateCode === DateCodes.DateTimeTBA ||
            contest.dateCode === DateCodes.DateTBA
              ? 'Date TBA'
              : formatTimestamp(contest.date, DateFormat.short)}
          </span>

          <span className={isMobile ? Font.f12_tall : Font.f14_tall}>
            {getHomeAwayText(currentTeam.homeAwayType, true)}
          </span>

          <ScheduleMascot contest={contest} size={isMobile ? 18 : 24} />

          <span className={isMobile ? Font.f12_bold_tall : Font.f14_bold_tall}>
            {isTeamTBA ? 'Opponent TBA' : name}
          </span>
          {city && state && (
            <Tablet andAbove>
              {!isRightRail && (
                <span className={`city-state ${Font.f14_tall}`}>
                  ({city}, {state})
                </span>
              )}
            </Tablet>
          )}
        </div>

        <div className="right">
          {imgSrc && (
            <Image src={imgSrc} alt="GameChanger" height={isMobile ? 16 : 24} />
          )}
          <span className={isMobile ? Font.f12_tall : Font.f14_tall}>
            {text}
          </span>
        </div>
      </StyledScheduleCalloutRow>
    </SmartAnchor>
  );
};

export default ScheduleCalloutRow;
